import {
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Tooltip,
	Typography,
	SelectChangeEvent
} from '@mui/material';

interface ISelectAnomalia {
	options: {
		value: string;
		label: string;
		helperText?: string;
	}[];
	label: string
	multi?: boolean
	value: string
	onChange: (event: SelectChangeEvent) => void;
	disabled?: boolean
	required?: boolean
	erro?: boolean
}

export default function SelectAnomalia({ options, label, onChange, value, disabled, required, erro }: ISelectAnomalia) {
	return (
		<FormControl fullWidth>
			<InputLabel id='estrutura-label' required={required} error={erro}>{label}</InputLabel>
			<Select
				labelId='estrutura-label'
				fullWidth
				value={value}
				onChange={onChange}
				disabled={disabled}
				required={required}
				error={erro}
			>
				{options.map((option) => (
					<MenuItem key={option.value} value={option.value}>
						{option.helperText ? (
							<Tooltip
								title={<Typography fontSize={14}>{option.helperText}</Typography>}
								placement="right"
								arrow
							>
								<span>{option.label}</span>
							</Tooltip>
						) : (
							option.label
						)}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
}